<template>
  <b-card header="Add new Lock Group">
    <div id="cover" style="position: fixed; height: 100%; width: 100%; top:0; left: 0; background: rgba(255, 255, 255, 0.8); z-index:9999;">
      <div style="color:white;position: absolute; margin: auto; top: 0; right: 0; bottom: 0; left: 0; width: 200px; height: 30px; border-radius: 3px;">
      <img class="navbar-brand-full" src="/static/img/preload.gif">
      </div>
    </div>
    <div>
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend><b-input-group-text>Name</b-input-group-text></b-input-group-prepend>
          <input type="text" v-model="formData.name" placeholder="name" class="form-control" @keyup.enter="submitData"></input>
          <b-input-group-append><b-input-group-text><i class="nav-icon icon-layers"></i></b-input-group-text></b-input-group-append>
        </b-input-group>
      </b-form-group>

      <div class="form-group form-actions">
        <b-button @click="submitData" type="button" size="sm" variant="primary">Save</b-button>
      </div>
    </div>

    <b-modal v-model="modalShowEmpty" ok-only ok-variant="secondary" ok-title="Ok">
      Name of lock group should not be empty. Please fill name for new lock group.
      <div slot="modal-footer" class="w-100">
         <b-btn size="sm" class="float-right" variant="primary" @click="this.modalShowEmpty = !this.modalShowEmpty">
           Ok
         </b-btn>
       </div>
    </b-modal>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/lockgroups/add'
const API_EDIT = BASE + '/api/lockgroups/edit'
const API_WITH_ID = BASE + '/api/lockgroups/detail'
const API_LIST = BASE + '/api/lockgroups/list'

async function getData (id) {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    lockGroupId: id,
    locationId: localStorage.getItem('locationId')

  }
  let res = await postdata(API_WITH_ID, parameters)
  return res.lockGroup
}

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  })
    .then(res => res.json())
}

async function getLockgroups () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token'),
    locationId: localStorage.getItem('locationId')
  }
  let res = await postdata(API_LIST, parameters)
  return res.lockGroups
}

export default {
  name: 'lock-group-form',
  data () {
    return {
      modalShowEmpty: false,
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        name: '',
        groupId: '',
        locationId: localStorage.getItem('locationId')
      }
    }
  },
  props: ['locationName', 'locationDescription', 'lockGroupId'],
  mounted () {
    if (localStorage.getItem('token')) {
      let id = this.$route.params.id
      if (id > 0) {
        getData(id).then(response => {
          this.$data.formData.name = response.name
        })
      }
    }
    document.getElementById('cover').style.display = 'none'
  },
  methods: {
    submitData (evt) {
      evt.preventDefault()
      let id = this.$route.params.id
      if (this.formData.name !== '') {
        if (id > 0) {
          this.formData.groupId = id
          postdata(API_EDIT, this.formData)
            .then(data => {
              getLockgroups().then(dataList => {
                this.$root.$emit('lockGroups', dataList)
              })
              console.log(data)
            })
            .catch(error => {d
              console.error(error)
            })
        } else {
          postdata(API, this.formData)
            .then(data => {
              if (data.lockgroup && data.lockgroup.id > 0) {
                let localLocationList = localStorage.getItem('localLocationsList')
                let locationId = localStorage.getItem('locationId')
                
                if(localLocationList) {
                  data.lockgroup.locksCount = 0
                  localLocationList = JSON.parse(localLocationList)
                  localLocationList.find(location => location.id == locationId).lockgroups.push(data.lockgroup)
                  localStorage.setItem('localLocationsList', JSON.stringify(localLocationList))
              

                  //this.$data.formData.name = localLocationList.find(location => location.id == locationId).lockgroups
                  let updatedLockgroups = localLocationList.find(location => location.id == locationId).lockgroups
                  this.$root.$emit('lockGroups', updatedLockgroups)
                }
              }
              this.$data.formData.name = ''
            })
            .catch(error => {
              console.error(error)
            })
        }
        this.modalShowEmpty = false
      } else {
        this.modalShowEmpty = true
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/views/base/LockGroupForm.vue